import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const SocialProof = () => {
  const socialContent = [
  {
    image: "https://images.unsplash.com/photo-1670201203116-26644750a726",
    alt: 'Woman applying luxury skincare product with glowing complexion',
    username: '@beautyvibes',
    likes: 1243
  },
  {
    image: "https://images.unsplash.com/photo-1718899904984-bd1fc08416e4",
    alt: 'Close-up of perfect makeup application showing flawless skin',
    username: '@glowgetter',
    likes: 2156
  },
  {
    image: "https://images.unsplash.com/photo-1617377223527-db2184d73c40",
    alt: 'Elegant beauty product flatlay with flowers and gold accents',
    username: '@luxebeauty',
    likes: 1876
  },
  {
    image: "https://images.unsplash.com/photo-1659323989191-81ec36b70f6c",
    alt: 'Woman with radiant skin holding premium skincare bottle',
    username: '@skincarejunkie',
    likes: 3421
  }];


  const influencers = [
  {
    name: 'BeautyByEmma',
    followers: '2.5M',
    image: "https://images.unsplash.com/photo-1648786220378-8407599cdfdc",
    alt: 'Beauty influencer Emma with professional makeup'
  },
  {
    name: 'GlowWithAva',
    followers: '1.8M',
    image: "https://images.unsplash.com/photo-1659323989191-81ec36b70f6c",
    alt: 'Skincare expert Ava demonstrating products'
  },
  {
    name: 'MakeupBySophie',
    followers: '3.2M',
    image: "https://images.unsplash.com/photo-1631237535331-8d5f0a7bacbe",
    alt: 'Makeup artist Sophie with beauty products'
  },
  {
    name: 'TheBeautyEdit',
    followers: '1.5M',
    image: "https://images.unsplash.com/photo-1606761353220-93fa83e332ca",
    alt: 'Beauty editor reviewing premium products'
  }];


  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-heading font-bold text-foreground mb-4">

            Join Our Community
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-lg text-muted-foreground max-w-2xl mx-auto">

            See what beauty lovers are sharing about their favorite products
          </motion.p>
        </div>

        {/* Social Feed Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
          {socialContent?.map((content, index) =>
          <motion.div
            key={content?.username}
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
            whileHover={{ scale: 1.05 }}
            className="relative group cursor-pointer overflow-hidden rounded-xl">

              <img
              src={content?.image}
              alt={content?.alt}
              className="w-full aspect-square object-cover" />

              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-3 left-3 right-3">
                  <p className="text-white font-semibold mb-1">{content?.username}</p>
                  <div className="flex items-center gap-1 text-white">
                    <Icon name="Heart" size={16} className="fill-current" />
                    <span className="text-sm">{content?.likes?.toLocaleString()}</span>
                  </div>
                </div>
              </div>
            </motion.div>
          )}
        </div>

        {/* Influencer Partnerships */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-gradient-to-r from-primary/10 via-accent/10 to-primary/10 rounded-2xl p-8">

          <h3 className="text-2xl font-heading font-bold text-foreground text-center mb-8">
            Trusted by Leading Beauty Influencers
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {influencers?.map((influencer, index) =>
            <motion.div
              key={influencer?.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="text-center">

                <div className="relative mb-3 inline-block">
                  <img
                  src={influencer?.image}
                  alt={influencer?.alt}
                  className="w-16 h-16 rounded-full object-cover border-2 border-primary" />

                  <div className="absolute -bottom-1 -right-1 bg-primary rounded-full p-1">
                    <Icon name="CheckCircle" size={16} className="text-primary-foreground" />
                  </div>
                </div>
                <p className="font-semibold text-foreground">{influencer?.name}</p>
                <p className="text-sm text-muted-foreground">{influencer?.followers} followers</p>
              </motion.div>
            )}
          </div>
        </motion.div>
      </div>
    </section>);

};

export default SocialProof;